import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, HStack } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import { BatterySelector } from 'store/selectors';

import AppRoutes from 'config/AppRoutes';
import PageLayout from 'ui/layout/PageLayout';
import { updateBattery } from 'store/answers/answersSlice';
import Button from 'ui/molecules/Button';

import VideoBlock from 'components/VideoBlock';
import useStepNavigation from 'utils/hooks/useStepNavigation';
import useAsset, { AssetType } from 'utils/hooks/useAsset';

const PageBatteryOption = () => {
  const currentRoute = AppRoutes.BATTERY_OPTION;
  const dispatch = useDispatch();
  const { navigateToNextStep, navigateToPreviousStep } =
    useStepNavigation(currentRoute);
  const { t } = useTranslation();
  const userValue = useSelector(BatterySelector);
  const [currentValue, setCurrentValue] = useState<boolean | undefined>(
    userValue
  );

  const videoUrl = useAsset(
    AssetType.VIDEO,
    `/05-batterie/BATTERIE${currentValue ? ' OUI ' : ' NON '}1000.mp4`
  );
  const batteryImageUrl = useAsset(
    AssetType.VIDEO,
    '/05-batterie/BATTERIE_SEULE.png'
  );

  const handleChange = (newVal: boolean) => {
    setCurrentValue(newVal);
    dispatch(updateBattery(newVal));
  };

  const handleContinue = () => {
    navigateToNextStep();
  };

  // --------------------- effects ------------------------

  // --------------------- render ------------------------

  return (
    <PageLayout
      title={t('BATTERY_OPTION_title')}
      buttonLabel={t('common.continue')}
      buttonCallback={handleContinue}
      backButton
      backCallback={navigateToPreviousStep}
    >
      <Box height={{ base: '250px', md: '250px' }}>
        <VideoBlock
          mt={{ sm: '-20px', md: '-50px' }}
          videoUrl={videoUrl}
          height={{ base: '300px', md: '350px' }}
          previewImageUrl={batteryImageUrl}
        />
      </Box>

      <HStack
        w={{ base: 'full', md: '60%' }}
        boxShadow="base"
        p="5px"
        borderRadius="25px"
        bgColor="white"
        bg="white"
        justifyContent="space-between"
      >
        <Button
          variant={currentValue ? 'radio-selected' : 'radio'}
          w="50%"
          onClick={() => handleChange(true)}
        >
          {t('common.yes')}
        </Button>
        <Button
          variant={!currentValue ? 'radio-selected' : 'radio'}
          w="50%"
          onClick={() => handleChange(false)}
        >
          {t('common.no')}
        </Button>
      </HStack>
    </PageLayout>
  );
};

export default PageBatteryOption;
